var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrehenAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen_Auto__Icn/40px/Drehen_Auto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.12,20.84 L18.22,35 L15.34,35 L14.02,31.76 L7.88,31.76 L6.6,35 L3.78,35 L9.94,20.84 L12.12,20.84 Z M10.96,23.84 L8.74,29.6 L13.14,29.6 L10.96,23.84 Z M36,20 L36,25.2857143 L34,25.2857143 L33.9992502,22.9233295 L33.8178256,23.0545725 C30.816402,25.1529973 26.5646296,26.3664025 22.0122502,26.3664025 C20.7415212,26.3664025 19.4901671,26.2723728 18.2769512,26.0881734 L17.6736083,25.9885775 L18.0249768,24.0196843 C19.3085578,24.2487521 20.647123,24.3664025 22.0122502,24.3664025 C25.7139927,24.3664025 29.1708818,23.4957749 31.7524135,22.0005227 L29.0769231,22 L29.0769231,20 L36,20 Z M8.01225018,16.0806882 C8.01225018,16.9791962 8.26131207,17.8618863 8.75019892,18.7079809 L8.90405049,18.9606906 L7.21957711,20.0389065 C6.48981768,18.8988191 6.07857815,17.6690701 6.01962864,16.3990136 L6.01225018,16.0806882 L8.01225018,16.0806882 Z M21,6.66632952 C29.642669,6.66632952 36.7959252,11.0191805 36.9957109,16.7074519 L37,16.9520438 L35,16.9520438 C35,12.5029348 28.8024068,8.66632952 21,8.66632952 C17.3249081,8.66632952 13.8911568,9.52446617 11.3157297,11.0000114 L14,11 L14,13 L7.07692308,13 L7.07692308,7.71428571 L9.07692308,7.71428571 L9.07525018,10.0633295 L9.19442459,9.97815954 C12.1958482,7.87973472 16.4476206,6.66632952 21,6.66632952 Z",
    id: ".._.._src_svg_Icn_40px_Drehen_Auto__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrehenAuto);
export default __webpack_public_path__ + "static/media/Drehen_Auto.2433e05fb874501d3238f9e697a70a02.svg";
export { ForwardRef as ReactComponent };